module.exports = __webpack_public_path__ + "img/tmh-tme-tc-ts-162x230.29d690a7.jpg";